const KEY = "ck-tiffin:theme";

export function readTheme() {
  try { return localStorage.getItem(KEY) || "auto"; } catch { return "auto"; }
}

export function applyTheme(v) {
  const el = document.documentElement;
  if (v === "light" || v === "dark") el.setAttribute("data-theme", v); else el.removeAttribute("data-theme");
}

export function saveTheme(v) {
  try { localStorage.setItem(KEY, v); } catch { /* storage blocked */ }
  applyTheme(v);
}
